import { useMemo } from "react";

// TODO remove after 5.8.2 merged
const supportedLocales = new Set([
  "en",
  "en-ca",
  "en-gb",
  "es",
  "es-mx",
  "es-pr",
  "es-us",
  "fa",
  "fr",
  "fr-ca",
  "uk",
  "zh",
  "zh-cn",
]);
const localeOverrides: Record<string, string> = {
  "fr-us": "fr-ca",
  "cn-us": "zh-cn",
};

// https://day.js.org/docs/en/i18n/i18n
export const getAdapterLocale = () => {
  const htmlLangAttribute = document.documentElement.lang;
  console.log(htmlLangAttribute); // This will log the value of the lang attribute

  const normalized = htmlLangAttribute.trim().toLowerCase().replace(/_/g, "-");
  const [language, region] = normalized.split("-");

  if (localeOverrides[normalized]) {
    return localeOverrides[normalized];
  } else if (supportedLocales.has(normalized)) {
    return normalized;
  } else if (supportedLocales.has(language)) {
    return language;
  } else {
    return "en";
  }
};

export function useNumberFormat(options?: Intl.NumberFormatOptions) {
  const locale = getAdapterLocale(); // TODO update when 5.8.2 merged
  return useMemo(
    () => new Intl.NumberFormat(locale, options),
    [locale, options && JSON.stringify(options)]
  );
}
